export default {
    title: 'Active carriers search'
};
